import { getGenerativeModel } from "firebase/ai";
import { ai } from "./firebase";

// JSON schema for a simple 1-page website
export const onePageSchema = {
  type: "object",
  properties: {
    pageTitle: { type: "string" },
    css: { type: "string" },
    html: { type: "string" },
  },
  required: ["pageTitle", "css", "html"],
};

export const editPageSchema = {
  type: "object",
  properties: {
    css: { type: "string" },
    html: { type: "string" },
    friendlyResponse: { type: "string" },
  },
  required: ["css", "html", "friendlyResponse"],
};


// Tell what the user wants to do.
export const userIntentModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash-lite",
  generationConfig: {
    responseMimeType: "application/json",
  },
});

export const updateWebsiteMetaModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

// Export the model
export const createWebsiteInfoModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash-lite",
  generationConfig: {
    responseMimeType: "application/json",
  },
});


export const onePageModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    responseSchema: onePageSchema,
    temperature: 0.7,
  },
});

export const editPlanModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const componentHtmlCssPatchModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const structurePatchModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const getHtmlCssMigrationPatchModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const generateHtmlCssComponentTreeModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const generateWebsitePage = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const fullPageModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});

export const editPageModel = getGenerativeModel(ai, {
  model: "gemini-2.5-flash",
  generationConfig: {
    responseMimeType: "application/json",
    temperature: 0.7,
  },
});